import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Antd from 'ant-design-vue'// 引入Ant Design Vue组件
import 'ant-design-vue/dist/antd.css' // 引入Ant Design Vue样式
import VCharts from 'v-charts'
import DictSelect from '@/components/DictSelect';
import SimplePagination from '@/components/SimplePagination';

import SvgIcon from './assets/SVG/SvgIcon'// svg组件
Vue.component('svg-icon', SvgIcon)
import './assets/SVG/index.js'

Vue.component('dict-select', DictSelect);
Vue.component('simple-pagination', SimplePagination);
Vue.use(VCharts)
Vue.use(Antd) //挂载到vue中
// local
import http from '@/api/config';
import errorMessage from '@/assets/common/errorMessage';
import requestUrl from '@/assets/common/commonUrl';
import util from "@/assets/common/util";
import constant from "@/assets/common/commonConstant";
import '@/assets/scss/reset.scss';
import '@/assets/scss/_themeColor.scss';
import '@/assets/images/icon/iconfont.css';
import Print from 'vue-print-nb'
import '@/directives/debounce.js';
import '@/directives/Jurisdiction.js';
import QRCode from "qrcodejs2";
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'Yp4XGziHfhbBS6XOECEBbTFN2MPWYEQy'
})


Vue.prototype.$qrCode = QRCode
Vue.use(Print);
Vue.use(ElementUI)
Vue.prototype.$http = http;
Vue.config.productionTip = false;
Vue.prototype.$errorMessage = errorMessage;
Vue.prototype.$requestUrl = requestUrl;
Vue.prototype.$utils = util;
Vue.prototype.$constant = constant;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;


router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
       next();
    } else if(to.path === '/register') {
      next();
    }else if(to.path === '/forget/password') {
      next();
    }else {// 每次页面跳转执行，token或openId錯誤，均提示跳转到首页
       let token = localStorage.getItem('resc');
    //    console.log(token)
       if (token === null || token === '' || token === undefined) {
        //   Toast('token错误，请重新登录')
          setTimeout(function () {
             next('/login');
          },100)
       }else{
          next();
       }
    }
 });
new Vue({
    router,
    axios,
    store,
    render: h => h(App)
}).$mount('#app')

